import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/ui/PageHeader';
import { StaffOnly } from '@/features/admin-content/StaffOnly';
import { useCan } from '@/features/admin-content/use-current-user';
import { SupportAdmin } from '@/features/support/SupportAdmin';

export const Route = createFileRoute('/admin/support')({
  component: AdminSupportPage,
});

function AdminSupportPage() {
  const allowed = useCan('users.admin');
  if (!allowed) {
    return <StaffOnly title="Admins only" description="Ask an admin for access." />;
  }
  return (
    <div className="grid gap-6">
      <PageHeader
        eyebrow="Staff portal"
        title="Teacher support"
        description="Which teacher looks after which student. New students are given a teacher with room automatically; you can move them."
      />
      <SupportAdmin />
    </div>
  );
}
